import type { ViewQueryNode } from '@salescore/core'
import { Array, Order, pipe } from 'effect'

import type { RSheetColumn, RSheetRecordNode } from '../../domain/column'
import { getReferencingNode } from './getReferencingNode'

/**
 * 参照列が指す参照先エンティティ型の識別子を返す。
 * コピー時はこの値を reference 値に埋め込み、ペースト時は貼り付け先カラムの参照先と比較して
 * 一致する場合のみ id ベースのペースト（検索を伴わない解決）を許可する。
 * 参照先ノードの依存 stream 名で判定するため、別ビュー・別カラムでも同一エンティティなら一致する。
 */
export const getReferencedStreamName = (
  column: RSheetColumn<RSheetRecordNode>,
  queryTree: ViewQueryNode | undefined,
): string | undefined => {
  if (column.field === undefined || queryTree === undefined) {
    return undefined
  }
  const referencedNode = getReferencingNode({ field: column.field, queryTree })
  if (referencedNode === undefined) {
    return undefined
  }
  const streamNames = referencedNode.meta.dependedStreamNames
  // subquery では複数になりうるため、順序非依存の安定キーにする
  return streamNames.length === 0 ? undefined : pipe(streamNames, Array.sort(Order.String), Array.join(','))
}

// 参照解決をしない場合のリゾルバ（削除経路・テスト等。常にラベル検索へフォールバックする）
export const getReferencedStreamNameNoOp = (): string | undefined => undefined
